import {Step} from '../../../../component/processPopup/ProcessPopup.types';
import {useTranslation} from 'react-i18next';
import {location, note} from '../../../../assets/symbols/symbols/Symbols.css';
import Gift from '../../../../assets/icons/gift';
import {CheckMarkCircle} from '../../../../assets/icons/CheckMarkCircle';
import SubscriptionTypeStep from './steps/SubscriptionTypeStep/SubscriptionTypeStep';
import DetailsStep from './steps/detailsStep/detailsStep';
import PricingStep from './steps/PricingStep/PricingStep';
import ReviewStep from './steps/ReviewStep/ReviewStep';
import * as css from './CreateSubscriptionPopup.css';

export const useSubscriptionSteps = (): Step[] => {
    const {t} = useTranslation('subscriptions');

    return [
        {
            label: t('subscriptionDetails'),
            completed: false,
            icon: <Gift />,
            comp: <SubscriptionTypeStep />
        },
        {
            label: t('subscriptionDescription'),
            completed: false,
            icon: <css.stepIcon icon={note} />,
            comp: <DetailsStep />
        },
        {
            label: t('priceMapAndMethod'),
            completed: false,
            icon: <css.stepIcon icon={location} />,
            comp: <PricingStep />
        },
        {
            label: t('reviewAndActivate'),
            completed: false,
            icon: <CheckMarkCircle />,
            comp: <ReviewStep />
        }
    ];
};

